import "./ContactFormTermsOfUse.module.css";
import Header from "@/reusable_sections/Header";
import FormTerms from "./sections/FormTerms";
import Footer from "@/reusable_sections/Footer";
export default function ContactFormTermsOfUsePage() {
  return <div>
      <Header />
      <FormTerms />
      <Footer />
    </div>;
}